// eslint-disable-next-line import/prefer-default-export
export const DOCTOR_TYPES: string[] = [
  'All',
  'Young Ophta',
  'Non Young Ophta',
];
